import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const ThreeDotThreeDotTwo = () => {
  return (
    <ChangelogInstance version="3.3.2" date="2025-06-04">
      <li>
        Fixed missing features on in-trade-offer items in trade offers
      </li>
    </ChangelogInstance>
  );
}

export default ThreeDotThreeDotTwo;